import { map, catchError, switchMap, filter } from 'rxjs/operators';
import { Router } from "@angular/router";
import { Component, Input, OnInit } from "@angular/core";
import { DirectoryService } from "../../../services/directory.service";
import { DirectoryMoreService } from "../../../services/directorymore.service";
import { UserService } from "../../../services/user.service";
import { Title, Meta } from "@angular/platform-browser";

@Component({
    selector: "app-directory",
    templateUrl: "./directory.component.html",
    styleUrls: ["./directory.component.css"],
    standalone: false
})
export class DirectoryComponent implements OnInit {

  @Input("isCompactView") isCompactView = false;
  @Input("list") list = [];
  @Input("listdirectorymore") listdirectorymore = [];

  constructor(
    private directoryService: DirectoryService,
    private userService: UserService,
    private router: Router,
    private titleService: Title,
    private metaService: Meta
  ) {}

  ngOnInit(): void {
    if (!this.isCompactView) {
      this.setMetaData()
      this.titleService.setTitle("Directory")
    }
    
    this.directoryService.getDirectories().subscribe((response) => {
      if (response.success) {
        this.list = response.data;
      } else {
        this.userService.errorMessage(response.message);
      }
    });
  }

  setMetaData() {
    // this.userService.addMetaTag('name',"description",'content',"Directory");
  }

  onClickDirectyory(id, type, slug): void {
    const routes = {
      1: `tiles-manufacturers/${slug}`,
      2: `manufacturers/${slug}`,
      3: `manufacturers/${slug}`,
      4: `tiles/${slug}`,
      5: `tiles/${slug}` ,
      6: `tiles/${slug}`,
      7: `tiles/${slug}`,
      8: `tiles/${slug}`,
      9: `tiles/${slug}`,
      10: `tiles/${slug}`,
    };


    this.router.navigate([ routes[type] ? routes[type] : "/"], { state : {type : type }});
  }
}
